class EventBus {
	constructor() {
		this.eventHandlers = {};
	}

	subscribe(event, handler) {
		if (!this.eventHandlers[event]) {
			this.eventHandlers[event] = [];
		}
		this.eventHandlers[event].push(handler);
	}

	unsubscribe(event, handler) {
		const handlers = this.eventHandlers[event];
		if (handlers) {
			const index = handlers.indexOf(handler);
			if (index !== -1) {
				handlers.splice(index, 1);
			}
		}
	}

	publish(event, data) {
		const handlers = this.eventHandlers[event];
		if (handlers) {
			handlers.forEach((handler) => handler(data));
		}
	}
}

export default new EventBus();
